const unknownStatus = 0

function isObjectRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null
}

function getRecordStatus(record: Record<string, unknown>): number {
  if (typeof record.status === 'number') return record.status
  if (typeof record.statusCode === 'number') return record.statusCode

  return unknownStatus
}

function getNestedRecordStatus(record: Record<string, unknown>, key: string): number {
  const value = record[key]
  if (!isObjectRecord(value)) return unknownStatus

  return getRecordStatus(value)
}

function getMessageStatus(message: unknown): number {
  if (typeof message !== 'string') return unknownStatus

  const statusMatch = /status code (\d{3})/.exec(message)
  return statusMatch ? Number(statusMatch[1]) : unknownStatus
}

export function getHttpStatus(error: unknown): number {
  if (!isObjectRecord(error)) return unknownStatus

  return (
    getRecordStatus(error) ||
    getNestedRecordStatus(error, 'response') ||
    getNestedRecordStatus(error, 'cause') ||
    getMessageStatus(error.message) ||
    unknownStatus
  )
}

export function shouldRetryShareLinkResolution(failureCount: number, error: unknown) {
  const status = getHttpStatus(error)

  return status !== 400 && status !== 401 && status !== 403 && status !== 404 && failureCount < 3
}
